import { useContext } from 'react';
import { Auth, AuthContext } from '../context/authContext';

export const useAuth = (): Partial<Auth> => {
  return useContext(AuthContext);
};
